export default function reducer(
  state = {
    activateChannelList: '',
  },
  action
) {
  switch (action.type) {
    case 'ACTIVATE_CHANNEL_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'ACTIVATE_CHANNEL_SUCCESS': {
      return {
        ...state,
        changingStatus: 'success',
        activateChannelList: action.payload,
      };
    }
    case 'ACTIVATE_CHANNEL_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        activateChannelList: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
